













import {
  computed,
  defineComponent,
  ref,
  Ref,
  toRefs
} from '@nuxtjs/composition-api'
import CDatePicker from '~/components/shared/configurable/date/CDatePicker.vue'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import { format } from '~/utils/date'
import { SIMPLE_DATE_FORMAT } from '~/constants/date'
import { computeFieldState } from '~/utils/form'

export default defineComponent({
  components: { CDatePicker },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { max, min, name } = toRefs(props)
    const selectedDate = ref<Date | null>()
    const maxDate = computed(() => max && new Date(max.value))
    const minDate = computed(() => min && new Date(min.value))

    function onValue(v: Ref<any>) {
      if (v.value) {
        selectedDate.value = new Date(v.value)
      }
    }
    const { error, changeValue } = useDynamicForm(props, { onValue })

    function handleDateInput(date: Date) {
      changeValue(name.value, format(date, SIMPLE_DATE_FORMAT))
    }

    const inputState = computed(() => computeFieldState(error.value))

    return {
      maxDate,
      minDate,
      handleDateInput,
      inputState,
      selectedDate
    }
  }
})
